import { Box, Paper, Stack, Table, TableBody, TableContainer, TableHead, Typography } from '@mui/material';
import { BorderWrapper, Cell, HeaderText, RowText, StyledTableHead, StyledTableRow } from '@styles/CommonStyles';
import { formatCurrency } from '@shared/commonFunctions';
import { ICollections, ICollectionsProps } from './interfaces/interfaces';


export const COLLECTIONS_HEADERS = [
  'Member Number\nCreditor\nStatus\nNarratives',
  'Industry Code\nAccount Number',
  'Date Reported\nDate Verified\nDate Closed',
  'Amount\nBalance',
];

const renderCollectionsHeader = () => (
  <TableHead>
    <StyledTableHead>
      <Cell>
        <Stack>
          <HeaderText>Member Number</HeaderText>
          <HeaderText>Creditor</HeaderText>
          <HeaderText>Status</HeaderText>
          <HeaderText>Narratives</HeaderText>
        </Stack>
      </Cell>
      <Cell>
        <Stack>
          <HeaderText>Industry Code</HeaderText>
          <HeaderText>Account Number</HeaderText>
        </Stack>
      </Cell>
      <Cell>
        <Stack>
          <HeaderText>Date Reported</HeaderText>
          <HeaderText>Date Verified</HeaderText>
          <HeaderText>Date Closed</HeaderText>
        </Stack>
      </Cell>
      <Cell>
        <Stack>
          <HeaderText>Amount</HeaderText>
          <HeaderText>Balance</HeaderText>
        </Stack>
      </Cell>
    </StyledTableHead>
  </TableHead>
);

const renderCollectionsRows = (collections: ICollections[]) => (
  <TableBody>
    {collections?.map((data, index) => (
      <StyledTableRow
        key={data?.accountNumber}
        index={index}
      >
        <Cell>
          <Stack direction="column" gap={1} >
            <RowText fontWeight="bold !important">
              {data?.memberNumber ?? ''}
            </RowText>
            <RowText>
              {data?.creditor ?? ''}
            </RowText>
            <RowText>
              {data?.status ?? ''}
            </RowText>
            <RowText>{data?.narrative ?? ''}</RowText>
          </Stack>
        </Cell>
        <Cell>
          <Stack direction="column" minWidth="80px" gap={1} >
            <RowText>
              {data?.industryCode ?? ''}
            </RowText>
            <RowText>
              {data?.accountNumber ?? ''}
            </RowText>
          </Stack>
        </Cell>
        <Cell >
          <Stack direction="column" gap={1}>
            <RowText>{data?.dateReported ?? ''}</RowText>
            <RowText>{data?.balanceDate ?? ''}</RowText>
            <RowText>{data?.dateClosed ?? ''}</RowText>
          </Stack>
        </Cell>
        <Cell>
          <Stack direction="column" gap={1}>
            <RowText>{data?.amount ? formatCurrency(data.amount) : ''}</RowText>
            <RowText>{data?.balance ? formatCurrency(data.balance) : ''}</RowText>
          </Stack>
        </Cell>
      </StyledTableRow>
    ))}
  </TableBody>
);

export const Collections = ({ collections }: ICollectionsProps) => (
  <Box marginBottom={2}>
    <Typography fontWeight={600} variant="h3"> Collections </Typography>
    <BorderWrapper>
      <TableContainer component={Paper}>
        <Table>
          {renderCollectionsHeader()}
          {renderCollectionsRows(collections)}
        </Table>
      </TableContainer>
    </BorderWrapper>
  </Box>
);
